import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import SectionTitle from '../common/SectionTitle';
import Reveal from '../common/Reveal';

// Real completed projects, extracted from JSISCO's Facebook page posts.
const PROJECTS = [
  {
    id: 1,
    image: '/images/projects/taybeh-group.jpg',
    titleAr: 'مشروع نقل بالعبور — مجموعة طيبة (64.85 ك.و)',
    titleEn: 'Net-Metering Project — Taybeh Group (64.85 kW)',
    categoryAr: 'تجاري',
    categoryEn: 'Commercial',
  },
  {
    id: 2,
    image: '/images/projects/taybeh-school.jpg',
    titleAr: 'مدرسة طيبة الأساسية للبنات (30 ك.و)',
    titleEn: 'Taybeh Basic School for Girls (30 kW)',
    categoryAr: 'مدرسة',
    categoryEn: 'School',
  },
  {
    id: 3,
    image: '/images/projects/khatib-villa.jpg',
    titleAr: 'فيلا السيد نضال الخطيب (22.68 ك.و)',
    titleEn: 'Al-Khatib Family Villa (22.68 kW)',
    categoryAr: 'سكني',
    categoryEn: 'Residential',
  },
];

const ProjectsShowcase = () => {
  const { t, language } = useLanguage();
  const isAr = language === 'ar';

  return (
    <section className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4">
        <Reveal>
          <SectionTitle
            title={t('home.projects.title')}
            subtitle={t('home.projects.subtitle')}
          />
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.id} delay={i * 100}>
              <div className="group relative overflow-hidden rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-1 h-64">
                <img src={p.image} alt={isAr ? p.titleAr : p.titleEn}
                  width="400" height="256"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent flex items-end">
                  <div className="p-6 w-full">
                    <span className="text-xs font-semibold text-primary-300 uppercase tracking-widest mb-2 block">
                      {isAr ? p.categoryAr : p.categoryEn}
                    </span>
                    <h3 className="text-lg font-bold text-white leading-snug">
                      {isAr ? p.titleAr : p.titleEn}
                    </h3>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="text-center">
            <Link
              to="/projects"
              className="inline-flex items-center gap-2 px-8 py-4 border-2 border-primary-500 text-primary-600 dark:text-primary-400 rounded-xl font-semibold hover:bg-primary-500 hover:text-white transition-all duration-300"
            >
              {t('home.projects.viewAll')}
              <svg className="w-4 h-4 rtl:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ProjectsShowcase;
